export default class Realworks {
    constructor() {
        const dropdown = document.querySelector('#frmRealworks .places-dropdown');
        if (!dropdown) return;

        const summary = dropdown.querySelector('summary');
        const summaryText = dropdown.querySelector('[data-places-summary]');
        const updateSummary = () => {
            const selected = [...dropdown.querySelectorAll('input:checked')];

            summaryText.textContent = selected.length === 0
                ? 'Kies één of meer plaatsen'
                : selected.length <= 2
                    ? selected.map(input => input.nextElementSibling.textContent).join(', ')
                    : `${selected.length} plaatsen geselecteerd`;
        };

        updateSummary();
        dropdown.addEventListener('change', updateSummary);
        dropdown.closest('form').addEventListener('reset', () => {
            setTimeout(updateSummary, 0);
        });

        document.addEventListener('pointerdown', event => {
            if (!dropdown.contains(event.target)) dropdown.open = false;
        });

        dropdown.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                dropdown.open = false;
                summary.focus();
            }
        });
    }
}
